module.exports = __webpack_public_path__ + "img/7.8df17568.jpg";